import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    headerItemWrapper: {
        margin: '0 3px',
    },
    headerItem: {
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'row',
        borderRadius: 8,
        color: theme.palette.text.primary,
        fontSize: '16px',
        textTransform: 'capitalize',
        textDecoration: 'none',
        padding: '10px 15px',

        '& :first-child': {
            marginTop: 1,
            marginRight: 5,
        },

        [theme.breakpoints.up('lg')]: {
            '&:hover': {
                backgroundColor: '#C5c5c520',
            },
        },

        [theme.breakpoints.down('md')]: {
            margin: '10px',
        },
    },
    headerItemActive: {
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'row',
        borderRadius: 8,
        color: theme.palette.text.secondary,
        fontSize: '16px',
        textTransform: 'capitalize',
        textDecoration: 'none',
        padding: '10px 15px',

        '& :first-child': {
            marginTop: 1,
            marginRight: 5,
        },

        [theme.breakpoints.up('lg')]: {
            '&:hover': {
                backgroundColor: '#C5c5c520',
            },
        },

        [theme.breakpoints.down('md')]: {
            margin: '10px',
        },
        fontWeight: 'bold',
    },
    headerMenu: {
        display: 'flex',
        flex: 1,
        listStyleType: 'none',
        [theme.breakpoints.down('lg')]: {
            display: 'none',
        },
    },
    headerMenuMobile: {
        display: 'flex',
        flex: 1,
        listStyleType: 'none',
        flexDirection: 'column',
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        },
    },
}));
